import loadable from "@loadable/component";
import DeileryIcon from "../../Icons/DeileryIcon";
//@ts-ignore
import { tw } from "@careinfo/tailwind";

const DeliveryListComponent = loadable(
  () => import("../../components/Delivery/DeliveryList")
);

const DeliveryList = () => {
  return (
    <>
      <div
        className={tw`w-full flex justify-left gap-x-2 mb-6 uppercase font-extrabold items-center`}
      >
        <DeileryIcon />
        <span className={tw`text-[#5E5757] font-bold text-xl`}>Runsheet</span>
      </div>
      <DeliveryListComponent />
    </>
  );
};

export default DeliveryList;
